export let labels = null;
export let language = null;

/**
 * Initialize module by retrieve and set all keys for current type
 * @param {string[]} types Application codes
 * @param {string} langCode Current language to retrieve
 * @param {string} rootUrl Relative path to the exposed route
 */
export async function initialize (types, langCode = 'en', rootUrl = '') {
  language = langCode;
  if (!Array.isArray(types) || types.length === 0) {
    throw new Error(`Argument 'types' must be non-empty array but was '${types}'`);
  }
  labels = await fetchLabelsByTypes(types, rootUrl);
};

/**
 * Retrieves the label with the given key, with a beautifully modern function name!
 * @param key {string} The kay of the label to resolve. i.e. 'frameset.title', ...
 * @param {object} model { name: dynamicValue } ie "Hello {{ name }}"
 * @return {string}
 */
export function labelByKey (key, model = {}) {
  model = model ?? {};
  if (!key || key.trim().length === 0) {
    throw new Error(`Argument 'key' must be non-blank string but was '${key}'`);
  }
  if (typeof model !== 'object' || Array.isArray(model)) {
    throw new Error('Optional argument model should be an object');
  }

  let value = labels?.[key] ?? key;
  Object.keys(model).forEach((key) => {
    value = value.replaceAll(`{{${key}}}`, `${model[key]}`);
  });
  return value;
};

/**
 * Fetch all labels for all types
 * @param {string[]} types
 * @param {string} rootUrl Relative path to the exposed route
 * @returns
 */
export async function fetchLabelsByTypes (types, rootUrl) {
  const labels = (await Promise.all(types.map(type => fetchLabelsByType(type, rootUrl)))).reduce((a, b) => ({ ...a, ...b }), {});
  return labels;
};

/**
 * Fetch labels by type
 * @param {string} type
 * @param {string} rootUrl Relative path to the exposed route
 * @returns
 */
export async function fetchLabelsByType (type, rootUrl = '') {
  /* eslint-disable-next-line no-undef */
  const request = await fetch(`${rootUrl}/api/labels/${type}/${language}`)
    .catch(err => new Error(`Labels could not be fetched: ${err.message}`));

  if (request instanceof Error) {
    return {};
  }

  const results = await request.json();
  return results.reduce((o, r) => ({ ...o, [r.key]: r[language] }), {});
};

export default { initialize };
